var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.countryCode)?_c('span',{style:(_vm.tile ? 'display:inline-block;line-height:0;' : '')},[_c('img',{staticClass:"country-display",style:(_vm.imageStyle),attrs:{"src":_vm.imagePath},on:{"error":function($event){return _vm.imageError()}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }